import * as R from 'ramda'
import mergeConfig from 'coact/config/mergeConfig'

import formViewClientConfig from './formView/clientConfig.js'
import itemViewClientConfig from './itemView/clientConfig.js'

const config = mergeConfig(
  R.assocPath(
    ['models', 'purchaseReqs', 'views', 'form'],
    formViewClientConfig,
    {},
  ),
  R.assocPath(
    ['models', 'purchaseItems', 'views', 'item'],
    itemViewClientConfig,
    {},
  ),
)

export default fullConfig => mergeConfig(fullConfig, config)
